export default class NetworkMessageBox {
  constructor(container) {
    this.container = container;
    this.closeBtn = this.container.querySelector("button");
    this.wrapper = this.container.querySelector(".network-message-wrapper");
    this.closeBtn.addEventListener("click", () => {
      this.hide();
    });
    this.container.addEventListener("click", () => {
      this.hide();
    });
    this.wrapper.addEventListener("click", (e) => {
      e.stopImmediatePropagation();
    });
    this.closeBtn.addEventListener("click", () => {
      this.hide();
    });
  }

  show() {
    console.log("Network Message box: SHOW!!!!!!");
    this.container.classList.remove("hidden");
    this.wrapper.classList.add("bounceInUp");
  }

  hide() {
    console.log("hide!");
    setTimeout(() => {
      this.container.classList.add("hidden");
      this.wrapper.classList.remove("bounceOutDown");
    }, 1000);
    this.wrapper.classList.remove("bounceInUp");
    this.wrapper.classList.add("bounceOutDown");
  }
}
